import { useState, useEffect, useCallback } from 'react';

export const useCardsNavigation = (
  container: HTMLElement,
  itemWidth: number
) => {
  const [isPrevEnabled, setIsPrevEnabled] = useState(false);
  const [isNextEnabled, setIsNextEnabled] = useState(false);

  const updateArrowsState = useCallback(() => {
    if (!container) return;
    const { scrollLeft, scrollWidth, clientWidth } = container;
    setIsPrevEnabled(scrollLeft > 0);
    setIsNextEnabled(scrollLeft + clientWidth < scrollWidth - 1);
  }, [container]);

  useEffect(() => {
    if (!container) return;
    updateArrowsState();
    container.addEventListener('scroll', updateArrowsState);
    window.addEventListener('resize', updateArrowsState);
    return () => {
      container.removeEventListener('scroll', updateArrowsState);
      window.removeEventListener('resize', updateArrowsState);
    };
  }, [container, updateArrowsState]);

  const prevSlide = () => {
    if (!container) return;
    container.scrollBy({ left: -itemWidth, behavior: 'smooth' });
  };

  const nextSlide = () => {
    if (!container) return;
    container.scrollBy({ left: itemWidth, behavior: 'smooth' });
  };

  return {
    prevSlide,
    nextSlide,
    isPrevEnabled,
    isNextEnabled,
  };
};
